import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import * as R from 'Router/routes';
import {
  BankIdErrorPropsMap,
  getKeyByErrorValue,
  useErrorTranslation,
} from './errorTranslation';

export default function useBankIdError() {
  const navigate = useNavigate();
  const location = useLocation();

  // Getting sessionStatus from storage
  const rawStatus = sessionStorage.getItem(
    'sessionStatus',
  ) as (typeof BankIdErrorPropsMap)[keyof typeof BankIdErrorPropsMap];

  const statusFromStorage = getKeyByErrorValue(rawStatus);

  // Getting relevant translation by status
  const translation = useErrorTranslation(rawStatus);

  // Append error code to the URL as a query param
  useEffect(() => {
    if (rawStatus && statusFromStorage) {
      const params = new URLSearchParams(location.search);
      params.set('code', statusFromStorage);
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    }
  }, []);

  return {
    translation,
    statusFromRoute: rawStatus,
    handleSkip: () => navigate(R.MANUAL_OCR),
  };
}
